import { resetOverrides, overridesInit } from '@ringcentral/rwc-utils/src/override-api';
import { getInjectFunction } from '@ringcentral/rwc-bridge';

resetOverrides();
overridesInit(getInjectFunction());
